var map = {
	"./ion-accordion_2.entry.js": [
		19672,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-accordion_2_entry_js"
	],
	"./ion-action-sheet.entry.js": [
		25084,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-action-sheet_entry_js"
	],
	"./ion-alert.entry.js": [
		5809,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-alert_entry_js"
	],
	"./ion-app_8.entry.js": [
		76442,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-app_8_entry_js"
	],
	"./ion-avatar_3.entry.js": [
		48142,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-avatar_3_entry_js"
	],
	"./ion-back-button.entry.js": [
		94954,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-back-button_entry_js"
	],
	"./ion-backdrop.entry.js": [
		49972,
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-backdrop_entry_js"
	],
	"./ion-breadcrumb_2.entry.js": [
		55926,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-breadcrumb_2_entry_js"
	],
	"./ion-button_2.entry.js": [
		45246,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-button_2_entry_js"
	],
	"./ion-card_5.entry.js": [
		62216,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-card_5_entry_js"
	],
	"./ion-checkbox.entry.js": [
		1804,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-checkbox_entry_js"
	],
	"./ion-chip.entry.js": [
		40773,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-chip_entry_js"
	],
	"./ion-col_3.entry.js": [
		57197,
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-col_3_entry_js"
	],
	"./ion-datetime_3.entry.js": [
		43613,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-datetime_3_entry_js"
	],
	"./ion-fab_3.entry.js": [
		60340,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-fab_3_entry_js"
	],
	"./ion-img.entry.js": [
		33952,
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-img_entry_js"
	],
	"./ion-infinite-scroll_2.entry.js": [
		90566,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-infinite-scroll_2_entry_js"
	],
	"./ion-input.entry.js": [
		68689,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-input_entry_js"
	],
	"./ion-item-option_3.entry.js": [
		1898,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-item-option_3_entry_js"
	],
	"./ion-item_8.entry.js": [
		66475,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-item_8_entry_js"
	],
	"./ion-loading.entry.js": [
		1587,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-loading_entry_js"
	],
	"./ion-menu_3.entry.js": [
		88785,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-menu_3_entry_js"
	],
	"./ion-modal.entry.js": [
		9313,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-modal_entry_js"
	],
	"./ion-nav_2.entry.js": [
		55968,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-nav_2_entry_js"
	],
	"./ion-picker-column-internal.entry.js": [
		99319,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-picker-column-intern-822428"
	],
	"./ion-picker-internal.entry.js": [
		4463,
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-picker-internal_entry_js"
	],
	"./ion-popover.entry.js": [
		2525,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-popover_entry_js"
	],
	"./ion-progress-bar.entry.js": [
		17324,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-progress-bar_entry_js"
	],
	"./ion-radio_2.entry.js": [
		46549,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-radio_2_entry_js"
	],
	"./ion-range.entry.js": [
		85539,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-range_entry_js"
	],
	"./ion-refresher_2.entry.js": [
		63772,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-refresher_2_entry_js"
	],
	"./ion-reorder_2.entry.js": [
		78700,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-reorder_2_entry_js"
	],
	"./ion-ripple-effect.entry.js": [
		48908,
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-ripple-effect_entry_js"
	],
	"./ion-route_4.entry.js": [
		6420,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-route_4_entry_js"
	],
	"./ion-searchbar.entry.js": [
		83222,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-searchbar_entry_js"
	],
	"./ion-segment_2.entry.js": [
		6548,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-segment_2_entry_js"
	],
	"./ion-select_3.entry.js": [
		32766,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-select_3_entry_js"
	],
	"./ion-slide_2.entry.js": [
		63996,
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-slide_2_entry_js"
	],
	"./ion-spinner.entry.js": [
		64199,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-spinner_entry_js"
	],
	"./ion-split-pane.entry.js": [
		72527,
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-split-pane_entry_js"
	],
	"./ion-tab-bar_2.entry.js": [
		81801,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-tab-bar_2_entry_js"
	],
	"./ion-tab_2.entry.js": [
		12041,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-tab_2_entry_js"
	],
	"./ion-text.entry.js": [
		47808,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-text_entry_js"
	],
	"./ion-textarea.entry.js": [
		4897,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-textarea_entry_js"
	],
	"./ion-toast.entry.js": [
		32170,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-toast_entry_js"
	],
	"./ion-toggle.entry.js": [
		17221,
		"common",
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-toggle_entry_js"
	],
	"./ion-virtual-scroll.entry.js": [
		47999,
		"node_modules_pnpm_ionic_core_6_1_13_node_modules_ionic_core_dist_esm_ion-virtual-scroll_entry_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 79801;
module.exports = webpackAsyncContext;